import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo1 from 'Icons/RMlogo.png';
import { RMLicenseHttpStatusCode } from './Licensing/RMLicenseHttpStatusCode';

function LicenseViolationBody({ headerText = 'Message', children, style = null }) {
  return (
    <div id="rm-message-license-violation-body-style" style={{ width: '100%', ...style }}>
      <div
        id="rm-message-license-violation-body-header"
        className="license-header"
        style={{ alignSelf: 'start', marginLeft: 24 }}
      >
        {headerText}
      </div>
      <div
        id="rm-message-license-violation-body-content"
        style={{
          borderTop: '1px solid #E0E0E0 ',
          borderBottom: '1px solid #E0E0E0',
          width: '100%',
          padding: '16px 12px 48px 24px',
          marginTop: 15,
        }}
        className="license-text"
      >
        {children}
      </div>
    </div>
  );
}

export default function RMMessage() {
  const location = useLocation();
  const navigate = useNavigate();
  const httpStatus = location.state?.detail ?? 0;

  function closeWindow() {
    navigate(-1);
  }

  return (
    <div id="rm-message-main-container" className="mainContainer">
      <div id="rm-message-header-row" className="headerRow">
        <div id="rm-message-header-logo" className="headerLogo">
          {}
        </div>
        <div id="rm-message-header-title" className="headerTitle">
          {}
        </div>
      </div>

      <div id="rm-message-inner-container" className="innerContainer">
        <div
          id="rm-message-login"
          className="login flex-y-center flex-column"
          style={{ width: 598 }}
        >
          <div
            id="rm-message-login-form"
            className="loginForm flex-y-center flex-column"
            style={{ padding: '24px' }}
          >
            <div id="rm-message-login-heading" className="loginHeading flex-y-center">
              <div id="rm-message-logo">
                <img id="rm-message-img-logo-1" src={Logo1} />
              </div>
              <div
                id="rm-message-license-header-style"
                style={{ marginLeft: 16, paddingBottom: 5 }}
              >
                <div id="rm-message-license-header-1" className="license-header">
                  ROCK MAKER
                  <span
                    id="rm-message-license-header-registered-logo"
                    className="registeredLogo"
                  >
                    &#174;
                  </span>
                </div>
                <div id="rm-message-license-header-2" className="license-header2">
                  Crystallization Software
                </div>
              </div>
            </div>

            <LicenseViolationBody
              headerText="Database Error"
              style={{ alignSelf: 'flex-start' }}
            >
              {httpStatus === RMLicenseHttpStatusCode.DBError && (
                <div id="rm-message-license-violation-status-db-error">
                  A network-related or instance-specific error occurred while establishing
                  a connection to SQL Server.
                </div>
              )}
            </LicenseViolationBody>

            <div
              id="rm-message-end-wrapper"
              className="fields flex-x-center"
              style={{ alignSelf: 'end', marginTop: 10 }}
            >
              {
                <button
                  id="rm-message-login-button"
                  name="activateOptionsButton"
                  className="loginButton"
                  style={{ width: 131, height: 48, marginLeft: 15 }}
                  onClick={() => closeWindow()}
                >
                  <span id="rm-message-login-button-text" className="buttonText">
                    CLOSE
                  </span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
